import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Row,
  Breadcrumb,
  Tag,
  Skeleton,
  Space,
  Image,
  Descriptions,
  Typography,
  Empty,
} from "antd";
import {
  HomeOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  FileImageOutlined,
  EnvironmentOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  InfoCircleOutlined,
  FileTextOutlined,
  FieldNumberOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useHttp } from "../../../utils/DataHendler";
import { UserContext } from "../../../context/User.context";
import { formatDate } from "../../../utils/DateTime";

export const PatrolDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getData } = useHttp();
  const { user } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState(null);

  useEffect(() => {
    fetchDetail();
    // eslint-disable-next-line
  }, [user, id]);

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await getData(
        `/security/patrol/inspection/${id}`,
        {},
        true
      );
      setDetailData(response.data);
    } catch (err) {
      setDetailData(null);
    }
    setLoading(false);
  };

  return (
    <Row justify="center">
      <Col xs={24} sm={22} md={18} lg={14}>
        <div
          style={{
            marginBottom: "30px",
            borderBottom: "2px solid #088395",
            padding: "10px 15px 0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Breadcrumb style={{ margin: 0 }}>
            <Breadcrumb.Item>
              <a onClick={() => navigate(-1)}>Patrol List</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontWeight: "bold" }}>
              Patrol Inspection Detail
            </Breadcrumb.Item>
          </Breadcrumb>
          <div
            style={{
              margin: 0,
              textAlign: "right",
              color: "#088395",
              fontWeight: "bold",
            }}
          >
            PATROL INSPECTION DETAIL
          </div>
        </div>
        {loading || !detailData ? (
          <Skeleton active paragraph={{ rows: 6 }} />
        ) : (
          <>
            <Descriptions
              bordered
              size="small"
              column={1}
              style={{ marginBottom: 24 }}
              labelStyle={{ width: 220, fontWeight: "bold" }}
              contentStyle={{ textAlign: "left" }} // rata kiri untuk item
            >
              {/* <Descriptions.Item label="Inspection ID">
                {detailData.id}
              </Descriptions.Item> */}
              <Descriptions.Item
                label={
                  <span>
                    <CalendarOutlined style={{ marginRight: 6 }} />
                    Inspection Time
                  </span>
                }
              >
                {detailData.inspection_time
                  ? formatDate(detailData.inspection_time)
                  : "-"}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FileTextOutlined style={{ marginRight: 6 }} />
                    Note
                  </span>
                }
              >
                {detailData.description}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FieldNumberOutlined style={{ marginRight: 6 }} />
                    Location Code
                  </span>
                }
              >
                {detailData.location_code}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <InfoCircleOutlined style={{ marginRight: 6 }} />
                    Location Name
                  </span>
                }
              >
                {detailData.location_name}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <EnvironmentOutlined style={{ marginRight: 6 }} />
                    Latitude
                  </span>
                }
              >
                {detailData.latitude}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <EnvironmentOutlined style={{ marginRight: 6 }} />
                    Longitude
                  </span>
                }
              >
                {detailData.longitude}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FileTextOutlined style={{ marginRight: 6 }} />
                    Location Description
                  </span>
                }
              >
                {detailData.location_description}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <UserOutlined style={{ marginRight: 6 }} />
                    Security Username
                  </span>
                }
              >
                {detailData.security_username}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <MailOutlined style={{ marginRight: 6 }} />
                    Security Email
                  </span>
                }
              >
                {detailData.security_email}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <PhoneOutlined style={{ marginRight: 6 }} />
                    Security Phone
                  </span>
                }
              >
                {detailData.security_phone}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <UserOutlined style={{ marginRight: 6 }} />
                    Security Name
                  </span>
                }
              >
                {detailData.security_name || "-"}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FieldNumberOutlined style={{ marginRight: 6 }} />
                    Security NIK
                  </span>
                }
              >
                {detailData.security_nik || "-"}
              </Descriptions.Item>
            </Descriptions>

            <div
              style={{
                margin: "20px 0 0 0",
                padding: "16px",
                border: "1px solid #e5e5e5",
                borderRadius: "8px",
                background: "#fafbfc",
              }}
            >
              <Typography.Title level={4} style={{ marginBottom: 16 }}>
                <FileImageOutlined
                  style={{ marginRight: 8, color: "#1677ff" }}
                />
                Attachment
              </Typography.Title>
              {detailData.attachment && detailData.attachment.length > 0 ? (
                <Row gutter={[16, 16]}>
                  {detailData.attachment.map((img, idx) => (
                    <Col xs={24} sm={12} key={idx}>
                      <div
                        style={{
                          border: "1px solid #e5e5e5",
                          borderRadius: 6,
                          padding: 8,
                          background: "#fff",
                          textAlign: "center",
                        }}
                      >
                        <Image
                          src={img}
                          width={180}
                          height={120}
                          style={{ objectFit: "cover", borderRadius: 4 }}
                          alt={`Attachment ${idx + 1}`}
                          preview={{ src: img }}
                          fallback="https://via.placeholder.com/180x120?text=No+Image"
                        />
                        <div
                          style={{ marginTop: 8, fontSize: 12, color: "#888" }}
                        >
                          Attachment {idx + 1}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              ) : (
                <div style={{ textAlign: "center", padding: "32px 0" }}>
                  <Empty
                    description={
                      <span style={{ color: "#888" }}>
                        Tidak ada attachment untuk inspeksi ini
                      </span>
                    }
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </Col>
    </Row>
  );
};
